import api from '.';
/**
 * Retorna os valores da tabela especifica
 * @param {*} empresaId
 * @param {*} tabela
 * @param {*} id
 * @param {*} descricao
 * @param {*} condicao
 * @param {*} filtro
 * @param {*} operacao
 * @param {*} funcionarioId
 * @returns
 */
export const dataList = async ({
    empresaId,
    tabela,
    id = 'id',
    descricao = 'descricao',
    condicao = null,
    filtro,
    contabil,
    operacao = null,
    funcionarioId = null,
    order,
    limite,
}) => {
    try {
        const { data } = await api.get('/serviceDataList', {
            params: {
                empresaId,
                tabela,
                condicao,
                id,
                descricao,
                filtro,
                contabil,
                operacao,
                funcionarioId,
                order,
                limite,
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

/**
 * Retorna os colaboradores
 * @param {*} empresaId
 * @param {*} filtro
 * @param {*} ativo
 * @param {*} tipo compras,extrusor,etc
 * @returns
 */
export const dataListColaborador = async ({ empresaId, filtro, ativo, tipo }) => {
    try {
        const { data } = await api.get('/serviceDataListColaborador', {
            params: {
                empresaId,
                filtro,
                ativo,
                tipo,
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        console.error('Erro na requisição:', error.response?.data || error.message);

        // OPÇÃO A: Lançar o erro para o componente tratar no try/catch dele
        throw error.response?.data || error;
    }
};

export const serviceDataListColaboradorOrRepresentante = async ({ empresaId, filtro, ativo, tipo }) => {
    try {
        const { data } = await api.get('/serviceDataListColaboradorOrRepresentante', {
            params: {
                empresaId,
                filtro,
                ativo,
                tipo,
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        console.error('Erro na requisição:', error.response?.data || error.message);

        // OPÇÃO A: Lançar o erro para o componente tratar no try/catch dele
        throw error.response?.data || error;
    }
};

/**
 * Retorna a lista de pessoas
 * @param {*} empresaId
 * @param {*} filtro comando digitado no datalist
 * @param {*} ativo true ou false
 * @param {*} tipo Ambos, Cliente ou Fornecedor
 * @param {*} funcionarioId pessoa vinculada do tipo funcionario
 * @returns
 */
export const dataListParceiro = async (empresaId, filtro, ativo, tipo, funcionarioId) => {
    try {
        const { data } = await api.get('/serviceDataListParceiro', {
            params: {
                empresaId,
                filtro,
                ativo,
                tipo,
                funcionarioId,
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

//produto por codigo de barra no datalist
export const dataListProduto = async (obj) => {
    try {
        const { data } = await api.post('/serviceDataListProduto', obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
/**
 * Retorna a lista de produtos
 * @param {*} empresaId
 * @param {*} filtro comando digitado no datalist
 * @param {*} filtraPorDiaHora no caso de restaurantes filtra por dia da semana e por café, almoço ou jantar
 * @param {*} tabelaPrecoId tabela de preço vinculada
 * @returns
 */
export const dataListTabelaPrecoItemProduto = async ({
    empresaId,
    tabelaPrecoId,
    filtro,
    filtraPorDiaHora,
    dataMovimento,
    utilizaRegraHoraMax,
    horaMaxCafe,
    horaMaxAlmoco,
    horaMaxJanta,
}) => {
    try {
        const { data } = await api.get('/serviceDataListTabelaPrecoItemProduto', {
            params: {
                empresaId,
                tabelaPrecoId,
                filtro,
                filtraPorDiaHora, //servi para a opção de restaurante
                utilizaRegraHoraMax,
                dataMovimento,
                horaMaxCafe,
                horaMaxAlmoco,
                horaMaxJanta,
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
/**
 * Retorna a lista de pessoa por vincula de locador, locatario ou fiador
 * @param {*} empresaId
 * @param {*} filtro comando digitado no datalist
 * @param {*} locador true ou false
 * @param {*} locatario true ou false
 * @param {*} fiador true ou false
 * @param {*} funcionarioId id do colaborador vinculado
 * @returns
 */
export const dataListParceiroImovel = async (empresaId, filtro, locador, locatario, fiador, funcionarioId, administrador) => {
    try {
        const { data } = await api.get('/serviceDataListParceiroImovel', {
            params: {
                empresaId,
                filtro,
                locador,
                locatario,
                fiador,
                funcionarioId,
                administrador,
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
/**
 *
 * @param {*} empresaId
 * @param {*} filtro
 * @returns
 */
export const dataListPessoaFisica = async (empresaId, filtro) => {
    try {
        const { data } = await api.get('/serviceDataListPessoaFisica', {
            params: {
                empresaId,
                filtro,
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const produto = async ({ empresaId, compra, venda, locavel, industria, filtro }) => {
    if (!empresaId || !filtro) {
        return [];
    }
    try {
        const { data } = await api.get('/dataList/produto', {
            params: {
                empresaId,
                compra,
                venda,
                locavel,
                industria,
                filtro,
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
